<template>
  <div class="my_wrap">
    <a-row type="flex">
      <a-col :span="4">
        <a-menu style="width: 100%" mode="inline" :defaultSelectedKeys="curMenu" @click="handleClick" >
          <a-menu-item key="1">{{ $t('myAccount.menu[0]') }}</a-menu-item>
          <a-menu-item key="2">{{ $t('myAccount.menu[1]') }}</a-menu-item>
          <a-menu-item key="3">{{ $t('myAccount.menu[2]') }}</a-menu-item>
          <a-menu-item key="4">{{ $t('myAccount.menu[3]') }}</a-menu-item>
        </a-menu>
      </a-col>
      <a-col :span="20" class="my_route">
        <router-view></router-view>
      </a-col>
    </a-row>
  </div>
</template>

<script>
export default {
  data () {
    return {
      curMenu: ['1']
    }
  },
  created () {
    // 初始默认菜单
    switch (this.$route.path) {
      case '/my/basic':
        this.curMenu = ['1']
        break
      case '/my/security':
        this.curMenu = ['2']
        break
      case '/my/bind':
        this.curMenu = ['3']
        break
      case '/my/gift':
        this.curMenu = ['4']
        break
    }
  },
  methods: {
    // 菜单点击
    handleClick (menu) {
      switch (menu.key) {
        case '1':
          this.$router.push(`/my/basic`)
          break
        case '2':
          this.$router.push(`/my/security`)
          break
        case '3':
          this.$router.push(`/my/bind`)
          break
        case '4':
          this.$router.push(`/my/gift`)
          break
      }
    }
  }
}
</script>

<style lang="less" scoped>
.my_wrap {
  background: #fff;
  padding: 20px 0;
  height: 100%;
  .ant-row-flex, .ant-menu {
    height: 100%;
  }
  .my_route {
    padding: 0 30px;
    float: right;
    overflow: hidden;
  }
}
</style>
